import React, { useEffect, useState } from "react";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { Col, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import TextError from "../../helpers/FormikHelper/TextError";
import { toast } from 'react-toastify';
import { OurTeamSchema } from "../../schema/TeamSchema";
import ourTeamServices from "../../services/ourTeam.services";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
const initialValues = {
    name: '',
    file: '',
    designation: '',
    description: ''
}

const OurTeamForm = ({ toggle, isAddMode, getData, selectedRow }) => {
    const [file, setFile] = useState(selectedRow?.imgUrl);
    function handleChange(e) {
        if(e.target.files.length>0){
        setFile(URL.createObjectURL(e.target.files[0]));
    }else{
        setFile('')
    }
    }
    const savedValues = {
        name: selectedRow?.name,
        file: '',
        designation: selectedRow?.designation,
        description: selectedRow?.description
    }
    const onSubmit = async (values) => {
        if (isAddMode === 'Add') {
            const result = await ourTeamServices.creatApi(values);
            if (result.data.status === true) {
                // actions.resetForm();
                getData()
                toggle()
                setFile('')
                toast.success('Record added successfully', { toastId: 'registration_success', autoClose: 3000 });
            } else {
                toast.error(result.data.message, { toastId: 'registration_fail', autoClose: 3000 });
            }
        } else {
            const result = await ourTeamServices.updateApi(selectedRow?._id, values)
            if (result.data.status === true) {
                // actions.resetForm();
                getData()
                toggle()
                setFile('')
                toast.success('Record updated successfully', { toastId: 'update_success', autoClose: 3000 });
            } else {
                toast.error(result.data.message, { toastId: 'update_fail', autoClose: 3000 });
            }
        }
    }
    
    useEffect(()=>{
        if(isAddMode==='Add'){
            setFile('')
        }
    },[isAddMode])
    return (
        <React.Fragment>
            <Formik
                initialValues={isAddMode === 'Add' ? initialValues : savedValues}
                validationSchema={OurTeamSchema('add')}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {({ setFieldValue, values }) => (<Form encType="multipart/form-data">
                    <ModalHeader toggle={toggle}>
                        <div className="card-title d-flex align-items-center">
                            <div>
                                <i className="bx bxs-user me-1 font-22 text-primary" />
                            </div>
                            <h5 className="mb-0 text-primary">{isAddMode === 'Add' ? 'Add Record' : 'Update Record'}</h5>
                        </div>
                    </ModalHeader>
                    <ModalBody className="">
                        <Col md={12}>
                            <div className="row g-3" >
                                <div className="col-md-12">
                                    <label htmlFor="name" className="form-label">
                                        Name
                                    </label>
                                    <Field type="text" className="form-control" id="name" name='name'
                                    />
                                    <ErrorMessage name='name' component={TextError} />
                                </div>
                                <div className="col-md-12">
                                    <label htmlFor="designation" className="form-label">
                                        Designation
                                    </label>
                                    <Field type="text" className="form-control" id="designation" name='designation'  />
                                    <ErrorMessage name='designation' component={TextError} />
                                </div>
                                <div className="col-md-12">
                                    <label htmlFor="description" className="form-label">
                                    description
                                    </label>
                                    {/* <Field type="text" className="form-control" id="description" name='description'
                                    /> */}
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={values.description}
                                        onReady={editor => {
                                            // You can store the "editor" and use when it is needed.
                                            console.log('Editor is ready to use!', editor);
                                        }}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setFieldValue("description", data);
                                        }}
                                        onBlur={(event, editor) => {
                                            // console.log('Blur.', editor);
                                        }}
                                        onFocus={(event, editor) => {
                                            // console.log('Focus.', editor);
                                        }}
                                    />
                                    <ErrorMessage name='description' component={TextError} />
                                </div>
                                <div className="col-md-12">
                                    <label htmlFor="file" className="form-label">
                                        Upload Image 
                                    </label>

                                    <input id="file" name="file" type="file" onChange={(event) => {
                                        setFieldValue("file", event.currentTarget.files[0]);
                                        handleChange(event)
                                    }} className="form-control" />
                           
                                       {file===undefined || file ===''?'': <img src={file}
                                              alt={selectedRow?.imgUrl}
                                            className="img-thumbnail mt-2"
                                            height={150}
                                            width={150} />}
                                </div>
                            </div>
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={toggle}
                        >
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary px-5">
                            {isAddMode === "Add" ? "Save" : "Update"}
                        </button>
                    </ModalFooter>
                </Form>
                )}
            </Formik>
        </React.Fragment>
    );
}

export default OurTeamForm;